import { combineReducers } from '@reduxjs/toolkit';
import bulkAssignReducer from './bulkAssign';
import bulkDeleteReducer from './bulkDelete/bulkDeleteSlice';
import bulkActionsSlice from './bulkActionsSlice';

export default combineReducers({
  bulkAssign: bulkAssignReducer,
  bulkDelete: bulkDeleteReducer,
  value: bulkActionsSlice,
});
